import { createContext } from 'react';
import { ShopFilterContextType } from './shop-filter-context-type';

export const ShopFilterContext = createContext<ShopFilterContextType | undefined>(
    undefined
);
